import { useEffect } from 'react';

import ChickenSpinner from '@/components/ChickenSpinner';

interface PdfDownloadProps {
  url: string;
}

const PdfDownload: React.FC<PdfDownloadProps> = ({ url }) => {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleDownload = (name?: string) => {
    const link = document.createElement('a');
    link.download = name ?? '';
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    handleDownload();
  }, [handleDownload]);

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <ChickenSpinner />
    </div>
  );
};

export default PdfDownload;
